export enum BookingOriginEnum {
	BOOKING_HEALTH = 'agendarConsulta',
	BOOKING_TELEHEALTH = 'agendarTeleconsulta',
	BOOKING_EXAM = 'agendarExame',
	BOOKING_ODONTO = 'agendarDentista',
	BOOKING_SCRIPT = 'booking_origin_script',
}
